export default function (str) {
  return str.toLowerCase().replace(/\s+/g, "-").slice(0, 50);
}
